import { Scroller, Slider } from '@cian/slider';
import * as React from 'react';

import { CarouselSlide } from './internal/components/CarouselSlide';
import { SLIDE_GAP, SLIDE_IMAGE_HEIGHT, SLIDE_WIDTH, SLIDER_OFFSET } from './internal/constants';
import { ArrayOfObjects } from '../../../../../types/ArrayOfObjects';

type Slide = {
  imageSrc: string;
  title: string;
  description: string;
};

export type SpecialProjectCarouselProps = {
  media: ArrayOfObjects<Slide>;
};

export const Carousel: React.FC<SpecialProjectCarouselProps> = props => {
  const { media } = props;

  return (
    <Slider>
      <Scroller columnGap={SLIDE_GAP} slideWidth="min-content" slideDrag offset={SLIDER_OFFSET}>
        {media.map(slide => (
          <CarouselSlide
            key={slide.id}
            width={SLIDE_WIDTH}
            height={SLIDE_IMAGE_HEIGHT}
            imageSrc={slide.imageSrc}
            title={slide.title}
            description={slide.description}
          />
        ))}
      </Scroller>
    </Slider>
  );
};
